import { MarketingPeriod } from '@app/core/models/partner/partner-marketing.model';

/** ISO с часовым поясом -> LocalDateTime бэкенда (YYYY-MM-DDTHH:mm:ss) в локальной зоне браузера */
export function isoToLocalDateTime(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  );
}

/** Период для эндпоинтов промокодов: они принимают LocalDateTime без часового пояса */
export function toLocalDateTimePeriod(period: MarketingPeriod): MarketingPeriod {
  return { from: isoToLocalDateTime(period.from), to: isoToLocalDateTime(period.to) };
}
